module.exports = __webpack_public_path__ + "img/common_ailments.249635c6.svg";